import { isDingdingMiniapp } from "../_utils/miniappEnvApp";
import { CONTAINER_NAME } from "../_utils/constant";
import { normalizeSet } from "../common";
var setClipboard = normalizeSet(function (args) {
  return isDingdingMiniapp ? dd.setClipboard(args) : my.setClipboard(args);
}, CONTAINER_NAME.ALIPAY);
export default setClipboard;